import React, { useState } from "react";
import "./AddProperty.css"; // Import your CSS file for styles
import { PropertyService } from "../../services/property";
import { useNavigate } from "react-router-dom";

const AddProperty: React.FC = () => {
  const [propertyDetails, setPropertyDetails] = useState({
    isMultiFamily: false,
    isRented: false,
    numOfUnits: 0,
    streetAddress: "",
    city: "",
    state: "",
    zipCode: "",
    purchasePrice: "",
    description: "",
    desiredRent: 0,
    actualRent: 0,
  });
  const navigate = useNavigate();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value, type } = e.target as
      | HTMLInputElement
      | HTMLTextAreaElement; // Type assertion
    const isCheckbox = type === "checkbox";

    setPropertyDetails({
      ...propertyDetails,
      [name]: isCheckbox ? (e.target as HTMLInputElement).checked : value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here, e.g., API call
    console.log("Property Details Submitted:", propertyDetails);

    try {
      await PropertyService.postProperty(propertyDetails);

      // On success, navigate to the property list page
      navigate("/main/properties");

      // alert('Property added successfully!');
    } catch (err) {
      alert("Failed to create property");
    }
  };

  return (
    <div className="bg">
      <div className="add-property-container">
        <h2 className="add-property-header">Add New Property</h2>
        <form onSubmit={handleSubmit} className="add-property-form">
          {/* Street Address */}
          <div className="form-group">
            <label htmlFor="streetAddress">Street Address:</label>
            <input
              type="text"
              id="streetAddress"
              name="streetAddress"
              value={propertyDetails.streetAddress}
              onChange={handleChange}
              required
              placeholder="Enter street address"
            />
          </div>
          {/* City, State, and Zip Code on One Row */}
          <div className="form-group address-row">
            <div className="address-field">
              <label htmlFor="city">City:</label>
              <input
                type="text"
                id="city"
                name="city"
                value={propertyDetails.city}
                onChange={handleChange}
                required
                placeholder="Enter city"
              />
            </div>

            <div className="address-field">
              <label htmlFor="state">State:</label>
              <input
                type="text"
                id="state"
                name="state"
                value={propertyDetails.state}
                onChange={handleChange}
                required
                placeholder="Enter state"
              />
            </div>

            <div className="address-field">
              <label htmlFor="zipCode">Zip Code:</label>
              <input
                type="text"
                id="zipCode"
                name="zipCode"
                value={propertyDetails.zipCode}
                onChange={handleChange}
                required
                placeholder="Enter zip code"
                maxLength={5}
                pattern="\d{5}"
              />
            </div>
          </div>

          {/* Purchase Price */}
          <div className="form-group">
            <label htmlFor="purchasePrice">Purchase Price:</label>
            <input
              type="number"
              id="purchasePrice"
              name="purchasePrice"
              value={propertyDetails.purchasePrice}
              onChange={handleChange}
              required
              placeholder="Enter purchase price"
            />
          </div>

          {/* Multi-Family Checkbox */}
          <div className="form-group" style={{ display: "inline" }}>
            <label>
              <input
                type="checkbox"
                name="isMultiFamily"
                checked={propertyDetails.isMultiFamily}
                onChange={handleChange}
              />
              Is this a multi-family property?
            </label>
          </div>
          {/* Number of Units */}
          {propertyDetails.isMultiFamily && (
            <div className="form-group">
              <label htmlFor="units">Number of Units:</label>
              <input
                type="number"
                id="units"
                name="units"
                value={propertyDetails.numOfUnits}
                onChange={handleChange}
                min="1"
                required
              />
            </div>
          )}

          <div className="form-group" style={{ display: "inline" }}>
            <label>
              <input
                type="checkbox"
                name="isRented"
                checked={propertyDetails.isRented}
                onChange={handleChange}
              />
              Is this a property Rented?
            </label>
          </div>
          <div className="form-group rent-row">
            <div className="form-group">
              <label htmlFor="actualRent">Actual Rent:</label>
              <input
                type="number"
                id="actualRent"
                name="actualRent"
                value={propertyDetails.actualRent}
                onChange={handleChange}
                required
                placeholder="Actual Rent"
              />
            </div>

            {propertyDetails.isRented && (
              <div className="form-group">
                <label htmlFor="desiredRent">Desired Rent:</label>
                <input
                  type="number"
                  id="desiredRent"
                  name="desiredRent"
                  value={propertyDetails.desiredRent}
                  onChange={handleChange}
                  required
                  placeholder="Desired rent"
                />
              </div>
            )}
          </div>
          {/* Description */}
          <div className="form-group">
            <label htmlFor="description">Description:</label>
            <textarea
              id="description"
              name="description"
              value={propertyDetails.description}
              onChange={handleChange}
              placeholder="Enter additional details about the property"
            />
          </div>
          <button type="submit" className="submit-button">
            Create Property
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddProperty;
